// Module
var code = "<div class=row> <div class=\"form-group col-xs-12\"> <div ui-codemirror=scriptConfig name=scriptEditor ui-refresh=model ng-model=model> </div> </div> </div>";
// Exports
module.exports = code;